<template>
    <v-card>
        <v-card-title primary-title class="font-weight-bold">
            Create Passenger
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs6>
                    Mobile Number (Username)
                </v-flex>
                <v-flex xs6>
                    <v-text-field label="Mobile" type="number" v-model="passenger.username" placeholder="988888888"/>
                </v-flex>
                <v-flex xs6>
                    First Name
                </v-flex>
                <v-flex xs6>
                    <v-text-field type="text" label="First Name" v-model="passenger.first_name"/>
                </v-flex>
                <v-flex xs6>
                    Last Name
                </v-flex>
                <v-flex xs6>
                    <v-text-field type="text" label="Last Name" v-model="passenger.last_name"/>
                </v-flex>
                <v-flex xs6>
                    Gender
                </v-flex>
                <v-flex xs6>
                    <choose-gender v-model="passenger.gender" label="Gender"/>
                </v-flex>
                <v-flex xs6>
                    Birthday
                </v-flex>
                <v-flex xs6>
                    <choose-date v-model="passenger.birthday" label="Birthdate"/>
                </v-flex>
            </v-layout>

            <v-btn color="primary" @click="save" :loading="loading">
                Save
            </v-btn>
            <v-alert icon="warning"
                     outline
                     :value="error !== ''" color="error">
                {{error}}
            </v-alert>
        </v-card-text>
    </v-card>
</template>

<script>
    import ChooseGender from "@/components/wasilni/input/ChooseGender";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";

    export default {
        name: "create-passenger",
        components: {ChooseGender, ChooseDate},
        data() {
            return {
                passenger: {
                    username: null,
                    first_name: null,
                    last_name: null,
                    gender: null,
                    birthday: null,
                    activation_code: "Wasilni"
                },
                error: "",
                loading: false
            }
        },
        methods: {
            async save() {
                this.loading = true;
                this.error = "";
                this.axios.post(this.api.ACTIONS.PASSENGERS, this.passenger)
                    .then(
                        res => {
                            this.$emit("create",res.data.data);
                        }
                    ).catch(
                    x => {
                        this.error = x.response.data.message;
                    }
                ).finally(
                    () => this.loading = false
                )
            }
        }
    }
</script>

<style scoped>

</style>